import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import VaStatus from "../requests/VaStatus";

const attentionTextByOrderType = {
  inventoryRequest:
    "Attention: This order must be picked from multiple warehouses. Ensure each pick list is completed.",
  internalWorkOrder:
    "Attention: These items are needed for additional inspection. They will not leave the warehouse.",
};

const warehousesKey = {
  inventoryRequest: "warehousesFromInventoryItems",
  internalWorkOrder: "warehousesFromInternalItems",
};

export default function Status({
  disabled,
  loading,
  inventoryRequest,
  changeStatus,
  orderType = "inventoryRequest",
  project,
}) {
  const warehouses = inventoryRequest?.[warehousesKey[orderType]];
  const warehouseNames = warehouses
    ?.map(warehouse => warehouse.name)
    .filter((name, index, array) => array.indexOf(name) === index)
    .join(", ");

  const hasMultipleWarehouses = warehouses?.length > 1;

  // For internal work orders with a destination warehouse, show transfer message
  const destinationWarehouse = inventoryRequest?.destinationWarehouse;
  const hasDestinationWarehouse = orderType === "internalWorkOrder" && destinationWarehouse;

  let attentionMessage = null;
  if (hasDestinationWarehouse) {
    attentionMessage = `Attention: These items will be transferred to the ${destinationWarehouse.name}`;
  } else if (hasMultipleWarehouses) {
    attentionMessage = attentionTextByOrderType[orderType];
  }

  return (
    <Box mb={3} sx={{ width: "100%" }}>
      <Box
        display="flex"
        alignItems={{ xs: "flex-start", sm: "center" }}
        mb={attentionMessage ? 2 : 0}
        flexDirection={{
          xs: "column",
          sm: "row",
        }}
        gap={1}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography fontWeight={500}>Status:</Typography>
          {loading ? (
            <Skeleton variant="rounded" width={120} height={36} />
          ) : (
            <VaStatus
              disabled={disabled}
              inventoryRequest={inventoryRequest}
              changeStatus={changeStatus}
              orderType={orderType}
              project={project}
            />
          )}
        </Box>
        {warehouseNames && (
          <Box display="flex" alignItems="center" gap={1} sx={{ marginLeft: { xs: 0, sm: "auto" } }}>
            <Typography fontWeight={500}>Picking From:</Typography>
            <Typography color="textSecondary">{warehouseNames}</Typography>
          </Box>
        )}
      </Box>

      {attentionMessage && (
        <Box textAlign="center" sx={{ width: "100%" }}>
          <Typography variant="h5" color="red" fontWeight={400}>
            {attentionMessage}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
